/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
// import styles from './PersonalInformation.module.scss'
import { changeObjectPropertyAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import { StatusInputWrapper } from '../../../../shared/components/StatusInputWrapper'

const NSHealthCardNumber = ({ t, validateNSHealthCardNumber, nsHealthCardNumberValid, nsHealthCardNumberError, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const nsHealthCardNumber = useSelector((state) => state.app.personalInformation.nsHealthCardNumber)

  const handleNSHealthCardNumber = (e) => {
    try {
      let nsHealthCardNumberElem = e.currentTarget.value.replace(/\D/g, '');
      dispatch(changeObjectPropertyAction('personalInformation', 'nsHealthCardNumber', nsHealthCardNumberElem))
      validateNSHealthCardNumber(nsHealthCardNumberElem)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurNSHealthCardNumber = (e) => {
    try {
      SetIsFocussed(false)
      let number = e.currentTarget.value.trim()
      dispatch(changeObjectPropertyAction('personalInformation', 'nsHealthCardNumber', number))
      validateNSHealthCardNumber(number)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <StatusInputWrapper
      isValid={nsHealthCardNumberValid}
      errorMsg={nsHealthCardNumberError}
      t={t}
      customClasses={'fw-20'}
      label={t('personal_info.ns_health_card_number')}
      id="NSHealthCardNumber" name="NSHealthCardNumber" type="text"
      isFocussed={isFocussed}
      aria-describedby="ns_health_card-number"
      onChange={handleNSHealthCardNumber}
      onBlur={onBlurNSHealthCardNumber}
      onFocus={() => SetIsFocussed(true)}
      value={nsHealthCardNumber}
      autoComplete="off"
      maxLength="10"
    />
  )
}

export default withTranslation('common')(NSHealthCardNumber)